import { render, staticRenderFns } from "./DownloadTestReports.vue?vue&type=template&id=8d341372&"
import script from "./DownloadTestReports.vue?vue&type=script&lang=js&"
export * from "./DownloadTestReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports